import ActivityNotifications from "@/components/7fcc/ActivityNotifications";
import { ACTIVITY_NOTIFICATIONS } from "@/data/startContent";
import {
  StartHero,
  StartVslSection,
  StartQuizSection,
  StartOpportunitySection,
  StartProofSection,
  StartVideoWinsSection,
  StartFaqSection,
  StartBottomCta,
  StartFooter,
} from "@/sections/start/StartSections";

// The /start campaign page — standalone mirror of /ready, fully fed
// from src/data/startContent.js. Not linked from any site navigation.
export default function StartPage() {
  return (
    <div className="theme-pink">
      {/* Funnel: hero → VSL → form → the opportunity → proof → FAQ */}
      <StartHero />
      <StartVslSection />
      <StartQuizSection />
      <StartOpportunitySection />
      <StartProofSection />
      <StartVideoWinsSection />
      <StartFaqSection />
      <StartBottomCta />
      <StartFooter />
      <ActivityNotifications notifications={ACTIVITY_NOTIFICATIONS} />
    </div>
  );
}
